import createCrud from '../crud';

export default createCrud({
    resource: 'billableItems',
    parent: 'budget'
  });